<template>
    <div id="search-page" class="bg-white">
        <h4 class="fab-home">Home</h4>

        <div
            class="vx-row mt-4 md:flex-row flex-col-reverse mt-6"
            v-if="hasFonds"
        >
            <div class="vx-col w-full">
                <div class="fab-series">
                    <h5 class="pl-3">
                        <strong>Series</strong>
                        <span class="fab-badge"
                            >{{ this.fonds.length  }} itens</span
                        >
                    </h5>
                    <div class="mt-5">
                        <a-row class="mt-5">
                            <a-col
                                :span="7"
                                class="fab-series-item"
                                v-for="(fond, index) in fonds"
                                :key="index"
                            >
                                <div class="mt-4">
                                    <svg
                                        width="24"
                                        height="19"
                                        viewBox="0 0 24 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M10.308 0.700625C9.852 0.249375 9.24 0 8.604 0H2.4C1.08 0 0.012 1.06875 0.012 2.375L0 16.625C0 17.9312 1.08 19 2.4 19H21.6C22.92 19 24 17.9312 24 16.625V4.75C24 3.44375 22.92 2.375 21.6 2.375H12L10.308 0.700625Z"
                                            fill="#FAC782"
                                        />
                                    </svg>
                                </div>
                                <div class="fab-series-item-texto ml-4 mt-3">
                                    <strong class="mb-3">
                                        <router-link
                                            :to="`/levels/${fond.id}/${fond.name}`"
                                            class="inline-block text-2xl fab-titulo"
                                            v-html="fond.name"
                                        ></router-link>
                                    </strong>
                                </div>
                            </a-col>
                        </a-row>
                    </div>
                </div>
                <!--vs-pagination
                    :total="pageCount"
                    v-model="currentPage"
                    class="mt-base"
                    @input="createSearchQuery(false)"
                ></vs-pagination-->
            </div>
        </div>
        <div v-if="lastSeenList.length > 0">
            <div class="fab-ultimos-acessos">
                <h5 class="pl-3 mb-4">
                    <strong>Acessos Recentes</strong>
                </h5>
                <a-table :columns="columns" :data-source="lastSeenList" :pagination="false">
                    <span slot="name" slot-scope="text, record">
                        <a-icon
                            class="mr-3"
                            v-if="record.type == 'mp3'"
                            style="fontSize:20px;color:green;"
                            type="sound"
                            theme="filled"
                        />
                        <a-icon
                            class="mr-3"
                            v-if="record.type == 'mp4'"
                            style="fontSize:20px;color:red;"
                            type="play-circle"
                            theme="filled"
                        />
                        <a-icon
                            class="mr-3"
                            v-if="record.type == 'txt'"
                            style="fontSize:20px;color:blue;"
                            type="file"
                            theme="filled"
                        />
                        <strong>
                            <router-link :to="`documents/${record.item_id}`" class="fab-table-nome">{{ text }}</router-link>
                        </strong>
                    </span>

                    <span slot="created_at" slot-scope="text">
                        {{text}}
                    </span>

                    <a slot="link_pasta" href="" slot-scope="text">{{
                        text
                    }}</a>

                    <template slot="acao" slot-scope="text, record">
                        <a>
                            <a-icon :theme="`${record.favorite ? 'filled' : 'outlined'}`" type="star" style="fontSize:20px;" @click="showModal(record.item_id, record.name)" />
                        </a>
                    </template>
                </a-table>
            </div>
        </div>
        <div
            class="vx-row mt-4 md:flex-row flex-col-reverse mt-6"
            v-if="showNoResultsWarning"
        >
            <div class="vx-col w-full">
                <p>Nenhum resultado encontrado</p>
            </div>
        </div>
        <div>
            <a-modal v-model="visible" title="Lista de favoritos" @ok="handleOk" okText="Favoritar" cancelText="Cancelar">
                <h6>Favoritar: {{this.modal_name_document}}</h6>
                <div  v-for="(item, index) in favoriteListOption"
                    :key="index" :class="`${modal_id_favorite == item.id || checkFavoriteExists(item.id) ? 'bg-gray' : ''}`"
                    @click="selectFavoriteId(item.id)"
                >
                    <p  >
                        {{item.name}}
                    </p>
                </div>

            </a-modal>
        </div>
    </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import filters from "../components/Filters";
import "video.js/dist/video-js.css";
import { sync, call } from "vuex-pathify";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isBoolean from "lodash/isBoolean";
import DdRequestNewPermission from "../components/DdRequestNewPermission";

const columns = [
    {
        title: "Nome",
        dataIndex: "name",
        key: "name",
        scopedSlots: { customRender: "name" }
    },
    {
        title: "Último acesso",
        dataIndex: "created_at",
        key: "created_at",
        scopedSlots: { customRender: "created_at" }
    },
    {
        title: "Nível",
        dataIndex: "shared_with",
        key: "shared_with"
    },
    {
        title: "Sistema de Arranjo",
        key: "folder",
        dataIndex: "folder",
        scopedSlots: { customRender: "folder" }
    },
    {
        title: "",
        dataIndex: "acao",
        scopedSlots: { customRender: "acao" }
    }
];

export default {
    async mounted() {
        // await this.readQuery();
        await this.fetchFavoriteList();
        await this.getSeenLast();
        await this.getFonds();
    },
    data() {
        return {
            searchTriggered: false,
            isSearchInProgress: false,
            selectedDocuments: [],
            columns,
            visible: false,
            favoriteListId: "",
            modal_id_document: false,
            modal_name_document: '',
            modal_id_favorite: false,
        };
    },
    watch: {
        query() {
            this.readQuery();
        }
    },
    computed: {
        ...sync([
            "document/startAudioAt",
            "document/startImageAt",
            "document/startVideoAt",
            "document/highlight",
            "search/currentPage",
            "search/pageCount",
            "search/results",
            "user/model.groupAlias",
            "search/filters",
            "search/lastSearch",
            "search/lastSeen",
            "search/fonds",
            "search/favorite_list_ids",
            "favoriteList/favoriteListOption"
        ]),
        isSelected() {
            if (this.selectedDocuments.length > 0) {
                return true;
            } else {
                this.favoriteListId = 0;
                return false;
            }
        },
        isAdmin() {
            return this.groupAlias === "administrator";
        },
        hasResults() {
            return this.results.length;
        },
        hasFonds() {
            return this.fonds.length;
        },
        showNoResultsWarning() {
            return !this.hasResults && this.searchTriggered;
        },
        term: sync("search/currentTerm"),
        lastSeenList: sync("search/lastSeen"),
        selectedFavoriteSearch: sync("favoriteSearches/selected"),
        hasSelectedFavoriteSearch() {
            const count = Object.keys(this.selectedFavoriteSearch).length;

            return count > 0;
        },
        query() {
            return this.$route.query;
        }
    },
    methods: {
        ...call({
            search: "search/search",
            reset: "search/reset",
            getSeenLast: "search/getSeenLast",
            getFonds: "search/getFonds",
            resetFilters: "search/resetFilters",
            resetFavorites: "favoriteSearches/reset",
            save: "favoriteSearches/save",
            fetchFavoriteList: "favoriteList/fetchFavoriteList",
            getFavoritesUserIdList: "search/getFavoritesUserIdList",
            addDocumentFavoriteList:
                "documentsFavoriteLists/addDocumentFavoriteList"
        }),
        loadLastSearch() {
            this.term = get(this.lastSearch, "currentTerm", "");
            this.currentPage = parseInt(get(this.lastSearch, "currentPage", 1));
            this.filter = get(this.lastSearch, "filters", {
                audio: false,
                image: false,
                video: false
            });
        },
        checkFavoriteExists(id) {
            return this.favorite_list_ids.includes(parseInt(id));
        },
        async readQuery() {
            // const query = this.$route.query;

            // if (query.term === undefined) {
            //     this.loadLastSearch();
            // } else {
            //     let term = get(query, "term", "");

            //     let currentPage = get(query, "current_page", 1);
            //     currentPage = parseInt(currentPage);

            //     let audio = get(audio, "audio", false);
            //     if (!isBoolean(audio)) {
            //         audio = audio == "true";
            //     }

            //     let video = get(query, "video", false);
            //     if (!isBoolean(video)) {
            //         video = video == "true";
            //     }

            //     let image = get(query, "image", false);
            //     if (!isBoolean(image)) {
            //         image = image == "true";
            //     }

            //     let startDate = get(query, "start_date", null);

            //     let endDate = get(query, "end_date", null);

            //     this.term = term;
            //     this.currentPage = currentPage;
            //     this.filters.audio = audio;
            //     this.filters.video = video;
            //     this.filters.image = image;
            //     this.filters.startDate = startDate;
            //     this.filters.endDate = endDate;
            // }

            // if (isEmpty(this.term)) {
            //     return;
            // }

            // if (query.term === undefined) {
            //     this.createSearchQuery();
            //     return;
            // }

            // await this.searchHandler();
        },
        showModal(id, name) {
            this.visible = true;
            this.modal_id_document = id;
            this.modal_name_document = name;
            this.selectedDocuments = id;


            this.getFavoritesUserIdList({id});
        },
        handleOk(e) {
            this.favoriteDocuments();
            this.visible = false;
            this.modal_id_document = false;
            this.modal_name_document = '';
        },
        selectFavoriteId(id) {
            this.modal_id_favorite = id;
            this.favoriteListId = id;
        },
        parseDescription(description) {
            description = this.$options.filters.truncate(description, 255);
            description = this.$options.filters.tailing(description, "...");

            return description;
        },
        async openDocument(result) {
            this.startAudioAt = result.audioTimestamp;
            this.startImageAt = result.imageIndex;
            this.startVideoAt = result.videoTimestamp;
            this.highlight = result.highlight;

            this.$router.push(`/documents/${result.id}`);
        },
        async saveHandler() {
            this.$vs.loading();
            try {
                await this.save({ term: this.term });
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Gravado com sucesso",
                    color: "success",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            } catch (error) {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro",
                    text:
                        "Ocorreu um erro ao salvar a pesquisa. Tente novamente, por favor.",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
        },
        async createSearchQuery(resetPagination = false) {
            // if (resetPagination) {
            //     this.currentPage = 1;
            // }

            // if (isEmpty(this.term)) {
            //     return;
            // }

            // this.$router.push({
            //     path: "/results",
            //     query: {
            //         term: this.term,
            //         current_page: this.currentPage,
            //         audio: this.filters.audio,
            //         image: this.filters.image,
            //         video: this.filters.video,
            //         end_date: this.filters.endDate,
            //         start_date: this.filters.startDate
            //     }
            // });

            // await this.searchHandler();
        },
        async searchHandler() {
            // if (this.isSearchInProgress) {
            //     return;
            // }

            // this.isSearchInProgress = true;

            // try {
            //     this.$vs.loading();
            //     await this.search();
            //     this.searchTriggered = true;
            //     this.$vs.loading.close();
            //     this.isSearchInProgress = false;
            // } catch (error) {
            //     this.$vs.loading.close();
            //     this.$vs.notify({
            //         title: "Erro",
            //         text:
            //             "Ocorreu um erro ao buscar os resultados. Tente novamente, por favor.",
            //         color: "danger",
            //         iconPack: "feather",
            //         icon: "icon-alert-circle"
            //     });
            //     this.isSearchInProgress = false;
            // }
        },
        select(event, result) {
            if (event.$event.srcElement.checked) {
                this.selectedDocuments.push(result.id);
            } else {
                let auxArray = [];
                this.selectedDocuments.map(s => {
                    if (s !== result.id) {
                        auxArray.push(s);
                    }
                });
                this.selectedDocuments = auxArray;
            }
        },

        async favoriteDocuments() {
            this.$vs.loading();
            try {
                await this.addDocumentFavoriteList({
                    favoriteListId: this.favoriteListId,
                    documentsIds: this.selectedDocuments
                });
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Documentos adicionados",
                    text:
                        "Os documentos foram adicionados a lista de favoritos com sucesso!",
                    color: "success",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });

                this.resetFavoriteDocuments();
            } catch (error) {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro",
                    text: error.message,
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
        this.modal_id_favorite = false;
        },

        resetFavoriteDocuments() {
            this.favoritelistsId = 0;
            this.selectedDocuments = 0;
        }
    },
    components: {
        videoPlayer,
        filters,
        DdRequestNewPermission
    }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/pages/search.scss";
em {
    background-color: yellow;
}

.search-Page__search-result {
    .request-new-permission-container {
        display: none;
    }

    &:hover .request-new-permission-container {
        display: inline-block;
    }
}
.fab-titulo {
    font-size: 14px !important;
    color: #292B35 !important;
    margin-top: 3px;
    text-decoration: none;
}

.btn-favorite {
    margin: 10px auto;
}

.fab-home {
    color: #106afe;
    padding: 10px;
    padding-top: 15px;
}
.fab-series {
    padding: 10px 10px 10px 0px;
}
.fab-series-item {
    padding: 5px;
    display: flex;
    margin: 20px;
    border: 1px solid rgb(204, 202, 202);
    border-radius: 5px;
}
.fab-ultimos-acessos {
    padding: 10px 10px 10px 0px;
}
.fab-badge {
    font-size: 10px;
    margin-left: 5px;
    background-color: rgb(204, 202, 202);
    padding: 5px 10px 5px 10px;
    border-radius: 10px;
}
.fab-series-item-texto {
    display: flex;
    flex-direction: column;
}
.fab-table-nome {
    font-size: 14px !important;
    color: #292B35 !important;
    text-decoration: none;
}
.bg-gray {
    background-color: rgb(204, 202, 202);
}
</style>
